import { render, staticRenderFns } from "./BulkAttributeAssignment.vue?vue&type=template&id=d12f70a4&"
import script from "./BulkAttributeAssignment.vue?vue&type=script&lang=js&"
export * from "./BulkAttributeAssignment.vue?vue&type=script&lang=js&"
import style0 from "./BulkAttributeAssignment.vue?vue&type=style&index=0&id=d12f70a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports